import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col space-y-5" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Providers List ")
const _hoisted_4 = { class: "flex flex-row space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add New")
const _hoisted_6 = { class: "col-span-full w-full flex flex-col space-y-2 rounded-md border-[1px] border-grey300 px-4 py-4" }
const _hoisted_7 = { class: "w-full flex flex-col py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_button = _resolveComponent("roof-button")!
  const _component_roof_table = _resolveComponent("roof-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_roof_header_text, { size: "xl" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_roof_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddProvider()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_roof_table, {
          ref: "providerTableRef",
          tableStructure: _ctx.Logic.Provider.ProviderTableStructure,
          paginatedData: _ctx.providerList,
          "table-date-source": _ctx.Logic.Provider.ProviderSource,
          "sub-page-route": '/providers/'
        }, null, 8, ["tableStructure", "paginatedData", "table-date-source"])
      ])
    ])
  ]))
}